"use strict";
/**
 * @packageDocumentation
 * @module IMessage
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBodyType = void 0;
var MessageBodyType;
(function (MessageBodyType) {
    MessageBodyType["REQUEST_TERMS"] = "request-terms";
    MessageBodyType["SUBMIT_TERMS"] = "submit-terms";
    MessageBodyType["REJECT_TERMS"] = "reject-terms";
    MessageBodyType["REQUEST_ATTESTATION_FOR_CLAIM"] = "request-attestation-for-claim";
    MessageBodyType["SUBMIT_ATTESTATION_FOR_CLAIM"] = "submit-attestation-for-claim";
    MessageBodyType["REJECT_ATTESTATION_FOR_CLAIM"] = "reject-attestation-for-claim";
    MessageBodyType["REQUEST_CLAIMS_FOR_CTYPES"] = "request-claims-for-ctypes";
    MessageBodyType["SUBMIT_CLAIMS_FOR_CTYPES"] = "submit-claims-for-ctypes-classic";
    MessageBodyType["ACCEPT_CLAIMS_FOR_CTYPES"] = "accept-claims-for-ctypes";
    MessageBodyType["REJECT_CLAIMS_FOR_CTYPES"] = "reject-claims-for-ctypes";
    MessageBodyType["REQUEST_ACCEPT_DELEGATION"] = "request-accept-delegation";
    MessageBodyType["SUBMIT_ACCEPT_DELEGATION"] = "submit-accept-delegation";
    MessageBodyType["REJECT_ACCEPT_DELEGATION"] = "reject-accept-delegation";
    MessageBodyType["INFORM_CREATE_DELEGATION"] = "inform-create-delegation";
})(MessageBodyType = exports.MessageBodyType || (exports.MessageBodyType = {}));
